/* eslint-disable unused-imports/no-unused-vars */
import React, {
  useState,
  useContext,
  useCallback,
  createContext,
  useMemo,
} from 'react';
import api from '../services';
// import { useAuth } from './auth';

const NotificationsContext = createContext({});

export function NotificationsProvider({ children }) {
  // const { isAuth } = useAuth();

  const [notifications, setNotifications] = useState({ content: [] });
  const [notificationsLoading, setNotificationsLoading] = useState({
    content: [],
  });
  const [lastNotifications, setLastNotifications] = useState({ content: [] });
  const [lastNotificationsLoading, setLastNotificationsLoading] =
    useState(false);

  const [markAsReadLoading, setMarkAsReadLoading] = useState(false);

  const listNotifications = useCallback(async (filters) => {
    try {
      setNotificationsLoading(true);
      const response = await api.notifications().listNotifications(filters);

      setNotifications(response);
    } finally {
      setNotificationsLoading(false);
    }
  }, []);

  const listLastFiveNotifications = useCallback(async (filters) => {
    try {
      setLastNotificationsLoading(true);
      const response = await api
        .notifications()
        .listLastFiveNotifications(filters);

      setLastNotifications(response);
    } finally {
      setLastNotificationsLoading(false);
    }
  }, []);

  const markAsRead = useCallback(async (id, isPaged = false) => {
    try {
      setMarkAsReadLoading(true);
      const response = await api.notifications().markAsRead(id);
      if (isPaged) {
        setNotifications((prevNotifications) => ({
          ...prevNotifications,
          content: prevNotifications.content.map((notification) =>
            notification.id === response.id
              ? { ...notification, isRead: 1 }
              : notification,
          ),
        }));
      } else {
        setLastNotifications((prevNotifications) => ({
          ...prevNotifications,
          content: prevNotifications.content.map((notification) =>
            notification.id === response.id
              ? { ...notification, isRead: 1 }
              : notification,
          ),
        }));
      }
    } finally {
      setMarkAsReadLoading(false);
    }
  }, []);

  const markAllAsRead = useCallback(
    async (id, isPaged = false) => {
      try {
        setMarkAsReadLoading(true);

        await api.notifications().markAllAsRead();
        await listNotifications();
      } finally {
        setMarkAsReadLoading(false);
      }
    },
    [listNotifications],
  );

  const contextValue = useMemo(
    () => ({
      listNotifications,
      notifications,
      notificationsLoading,
      listLastFiveNotifications,
      lastNotifications,
      lastNotificationsLoading,
      markAsRead,
      markAsReadLoading,
      markAllAsRead,
    }),
    [
      listNotifications,
      notifications,
      notificationsLoading,
      listLastFiveNotifications,
      lastNotifications,
      lastNotificationsLoading,
      markAsRead,
      markAsReadLoading,
      markAllAsRead,
    ],
  );

  return (
    <NotificationsContext.Provider value={contextValue}>
      {children}
    </NotificationsContext.Provider>
  );
}

export function useNotifications() {
  const context = useContext(NotificationsContext);

  if (!context)
    throw new Error('useNotifications must be used within an ToastProvider');

  return context;
}
